import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, merge } from "rxjs";
import { Router } from "@angular/router";
import { map, switchMap, shareReplay } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { IGlobalUIContext } from "../helper/IGlobalUIContext";
import { GlobalUIContext } from "../helper/GlobalUIContext";

@Injectable({
    providedIn: 'root',
})
export class ContextService {

    private contextObservables = new BehaviorSubject<Observable<IGlobalUIContext>[]>([of(new GlobalUIContext('ecoreps', ' ', ''))]);

    public context: Observable<IGlobalUIContext>;

    private _contextObservable: Observable<IGlobalUIContext>;

    public subscribeCover(coverObservable: Observable<IGlobalUIContext>) {
        this.contextObservables.next(this.contextObservables.value.concat([coverObservable]));
    }

    public nextContext(context: IGlobalUIContext) {
        this.contextObservables.next(this.contextObservables.value.concat([of(context)]));
    }

    constructor() {
        this.context = this.contextObservables.pipe(
            switchMap(observables => merge(...observables))
            , map(val => {
                return val;
            }), shareReplay(1))
    }


}
